import { render, staticRenderFns } from "./ArticlePlaceInfo.vue?vue&type=template&id=3a7be9a0&"
import script from "./ArticlePlaceInfo.vue?vue&type=script&lang=js&"
export * from "./ArticlePlaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports